import TopCaseStudy from './TopCaseStudy'

export default TopCaseStudy
